// extracted by mini-css-extract-plugin
export default {"page":"TopMenu_page__k4NaR","title":"TopMenu_title__GFIie","image":"TopMenu_image__aHzWc","right":"TopMenu_right__KOM3A","p":"TopMenu_p__RZkY+","icon":"TopMenu_icon__+ihVD"};